import DatePicker from './DatePicker.vue'

export default DatePicker

export const THIS_MONTH = 'this_month'
export const LAST_MONTH = 'last_month'
export const LAST_QUARTER = 'last_quarter'
export const LAST_3_MONTH = 'last_3_month'
export const LAST_6_MONTH = 'last_6_month'
export const LAST_12_MONTH = 'last_12_month'

// Used for shortcuts in date picker
// Strip time so the datepicker only deals with dates
function stripTime (d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate())
}

const getFirstDayOfMonth = (month) => {
  const date = new Date()
  const y = date.getFullYear()
  const m = date.getMonth() - month
  return new Date(y, m, 1)
};

const getLastDayOfMonth = (month) => {
  const date = new Date()
  const y = date.getFullYear()
  const m = date.getMonth() - month
  return new Date(y, m + 1, 0)
}

function getLastQuarter () {
  const now = new Date()
  const currentQuarter = Math.floor(now.getMonth() / 3)
  const prevQuarter = currentQuarter === 0 ? 3 : currentQuarter - 1
  const year = currentQuarter === 0 ? now.getFullYear() - 1 : now.getFullYear()
  const startMonth = prevQuarter * 3
  return {
    start: new Date(year, startMonth, 1),
    end: new Date(year, startMonth + 3, 0)
  }
}

export const SHORTCUTS = {
  [THIS_MONTH]: {
    text: 'This month',
    end: stripTime(new Date()),
    start: getFirstDayOfMonth(0)
  },
  [LAST_MONTH]: {
    text: 'Last month',
    end: getLastDayOfMonth(1),
    start: getFirstDayOfMonth(1)
  },
  [LAST_QUARTER]: {
    text: 'Last quarter',
    ...getLastQuarter()
  },
  [LAST_3_MONTH]: {
    text: 'Last 3 months',
    end: getLastDayOfMonth(1),
    start: getFirstDayOfMonth(3)
  },
  [LAST_6_MONTH]: {
    text: 'Last 6 months',
    end: getLastDayOfMonth(1),
    start: getFirstDayOfMonth(6)
  },
  [LAST_12_MONTH]: {
    text: 'Last year',
    end: getLastDayOfMonth(1),
    start: getFirstDayOfMonth(12)
  }
}
